// Small pieces of a plan's page (today's plans/parts.tsx): the stage meter
// and a phase's name.
import { STAGES, type StageCounts } from './state'

/** A bar of the issues by stage, in the board's state colours; nothing without issues. */
export function StageMeter({ counts, className = 'pv-meter' }: { counts: StageCounts; className?: string }) {
  const shown = STAGES.filter((stage) => counts[stage] > 0)
  if (shown.length === 0) return null
  return (
    <span className={className} aria-hidden="true">
      {shown.map((stage) => (
        <span key={stage} data-stage={stage} style={{ flexGrow: counts[stage] }} />
      ))}
    </span>
  )
}

const SHORT = /^(P\d+)\s+(.+)$/

/** `P1 An empty Poulpe`: its short name dimmed before the rest. */
export function PhaseName({ title }: { title: string }) {
  const parts = SHORT.exec(title)
  if (!parts) return <>{title}</>
  return (
    <>
      <span className="pv-card-key">{parts[1]}</span> {parts[2]}
    </>
  )
}
